<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Editar varroa" />

        <v-form ref="form" v-model="valid" lazy-validation>


            <v-text-field
                    color="orange"
                    label="Número de la colmena/núcleo*"
                    v-bind:value="infoVarroa.namecolmenar"
                    disabled
            ></v-text-field>

            <v-text-field
                    color="orange"
                    label="Número de la colmena/núcleo*"
                    v-bind:value="infoVarroa.namecolmena"
                    disabled
            ></v-text-field>


            <p for="date" style="font-size:0.69rem;"><b>Fecha de la visita*</b></p>
            <datepicker
                    style="margin-bottom:20px;"
                    name="date"
                    id="date"
                    v-model="infoform.date"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>

            <p class="v-messages__message">{{errors.date}}</p>

            <v-select
                    v-model="infoform.number"
                    class="form-group"
                    color="orange"
                    :items="optionsNumbers"
                    label="Número"
                    data-vv-name="infoform.number"
            ></v-select>

            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Notas, comentarios..."
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Editar varroa
            </v-btn>

        </v-form>


    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'

import axios from "axios";

export default {

    name: 'varroa-editar',
    components: {
        toolbar,
        loading,
        Datepicker
    },
    data() {
        return {

            toolbar: {
                return: '0'
            },

            es: es,

            errors: {
                date:'',
            },

            valid: true,

            isloading:'',

            optionsNumbers: [
              { text: '0', value: '0' },
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '8', value: '8' },
              { text: '9', value: '9' },
              { text: '10', value: '10' },
              { text: '11', value: '11' },
              { text: '12', value: '12' },
              { text: '13', value: '13' },
              { text: '14', value: '14' },
              { text: '15', value: '15' }
            ],

            alertForm:'success',
            responseform:'',
            alert: false,

            infoform: {
                idcolmena:'',
                date: '',
                number: '',
                description: ''
            },

            info: null,
            infoVarroa: null,
            response:null,

  }},
  created() {
  auth.getUserLogged()
    this.getTodos();
  },
  methods:{

        async getTodos(){

            var that = this

           await axios.get("https://appws.panimiel.com/new/index.php/api/hive_varroa/detail/"+this.$route.params.id).then((info) => {
              that.infoVarroa = info.data
              that.infoform.idcolmena = info.data.idcolmena
              that.infoform.date = info.data.date
              that.infoform.number = info.data.number
              that.infoform.description = info.data.description
            })
        },

        validate () {

            if(this.infoform.date===''){
                this.errors.date = "Debes insertar la fecha de la inspección."
            }else{

                this.alert = false
                this.isloading = true

                this.errors.date = ''

                axios.put('https://appws.panimiel.com/new/index.php/api/hive_varroa/'+this.$route.params.id, this.infoform).then((response) => {
                    this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true

                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible editar el test de varroa.'
                    }
                     this.alert = true

                 })

            }

        }

    }


};


</script>

<style scoped lang="scss">
</style>